import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { environment } from "./../../../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable, of } from "rxjs";
import { retry } from "rxjs/operators";
import { ConsultaMisRNTEntry } from "src/app/shared/entrys/consulta-mis-rnt.entry";
import { AuthService } from "src/app/shared/services/auth.service";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { DireccionEstandarEstablecimientoEntry } from "src/app/shared/entrys/direccion-estandar-establecimiento.entry";

@Injectable()
export class EstablecimientoComercioService
  implements RequestCRUD<EstablecimientoEntry, ResponseServiceModel> {
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private authService: AuthService,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError(
      "EstablecimientoComercioService"
    );
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/prestador/ObtenerEstablecimientos`,
        entry
      )
      .pipe(retry(2));
  }

  getRnt(
    entry: ConsultaMisRNTEntry,
    numeroPagina: number
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Rnt/ConsultaMisRnt?PageNumber=${numeroPagina}&PageSize=12`,
        entry
      )
      .pipe(retry(2));
  }

  getPrestador(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/Prestador/PorUsuario`, entry)
      .pipe(retry(2));
  }

  getEstablecimiento(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/${entry.establecimiento_id}`
      )
      .pipe(retry(2));
  }

  getEstablecimientoPorUsuario(
    entry: any,
    numeroPagina: number
  ): Observable<ResponseServiceModel> {
    if (this.authService.getRolDetalleUser() === TipoPrestador.Guia) {
      // tslint:disable-next-line:max-line-length
      return this.http
        .post<ResponseServiceModel>(
          `${this.API_URL}/Establecimiento/PorUsuario?PageNumber=${numeroPagina}&PageSize=12`,
          { usuario: entry.usuario }
        )
        .pipe(retry(2));
    } else {
      // tslint:disable-next-line:max-line-length
      return this.http
        .post<ResponseServiceModel>(
          `${this.API_URL}/Establecimiento/ValidosPorCIIU?PageNumber=${numeroPagina}&PageSize=12`,
          entry
        )
        .pipe(retry(2));
    }
  }

  getEstablecimientoContadorPorUsuario(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/prestador/ConsolidadoEstadosRnt`
      )
      .pipe(retry(2));
  }

  getAccionesPorRnt(
    entry: RNTPrestadorEntry
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Rnt/ConsultarAcciones`,
        entry
      )
      .pipe(retry(2));
  }

  getExpedirCertificadoPorRnt(entry: RNTPrestadorEntry): Observable<Blob> {
    return this.http
      .post<Blob>(`${this.API_URL}/ExpedirCertificado`, entry)
      .pipe(retry(2));
  }

  getExpedirCertificadoRegistroPorRnt(
    entry: RNTPrestadorEntry
  ): Observable<Blob> {
    return this.http
      .post<Blob>(`${this.API_URL}/ExpedirCertificadoRegistro`, entry)
      .pipe(retry(2));
  }

  verificarGuia(): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/CheckGuia`,
        null
      )
      .pipe(retry(2));
  }

  getParametro(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Parametro/DetallePorId`,
        entry
      )
      .pipe(retry(2));
  }

  // Filtros
  getTipoSolicitud(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/Solicitud/GetTipoSolicitudes`)
      .pipe(retry(2));
  }
  getSubCategorias(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/SubCategoria`)
      .pipe(retry(2));
  }
  getCamaras(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/CamaraComercio`)
      .pipe(retry(2));
  }
  getEstadosRNT(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/EstadosRnt`)
      .pipe(retry(2));
  }
  getEstadosSolicitud(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/EstadosSolicitud`)
      .pipe(retry(2));
  }

  // Filtros

  update(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    entry.activo = true;
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/Crear`,
        entry
      )
      .pipe(retry(2));
  }
  delete(entry: EstablecimientoEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getMensajeEliminacion(request) {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Parametro/DetallePorId`,
        request
      )
      .pipe(retry(2));
  }

  // Eliminar solicitud
  eliminarSolicitud(idSolicitud) {
    return this.http.put<ResponseServiceModel>(`${this.API_URL}/Solicitud/EliminarSolicitud/${idSolicitud}`, '').pipe(
      retry(2)
    );
  }
  public createReactivacionAnticipada(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Solicitud/CrearReactivacionAnticipada`,
        entry
      )
      .pipe(retry(2));
  }

  actualizarDireccionEstandarEstablecimiento(establecimiento_id: string, direccionEstandarEstablecimiento: DireccionEstandarEstablecimientoEntry) {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/establecimiento/${establecimiento_id}/DireccionEstandar`,
        direccionEstandarEstablecimiento
      )
      .pipe(retry(2));
  }
}
